(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
/* Native-scroll carousel. No product clones or changes to Dawn's quick-add flow. */
if (!customElements.get('imp-featured-carousel')) {
  class ImpFeaturedCarousel extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.init());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.measureFrame);
      cancelAnimationFrame(this.scrollFrame);
      clearTimeout(this.settleTimer);
      this.events?.abort();
      this.observer?.disconnect();
      this.endDrag(false);
      this.ready = false;
    }

    init() {
      if (this.ready || !this.isConnected) return;
      this.viewport = this.querySelector('[data-fc-track]');
      if (!this.viewport) return;
      this.cards = Array.from(this.viewport.children).filter(node => node.matches('.impressiko-product-card'));
      if (!this.cards.length) return;
      this.ready = true;
      this.events = new AbortController();
      this.controls = this.querySelector('[data-fc-controls]');
      this.prev = this.querySelector('[data-fc-prev]');
      this.next = this.querySelector('[data-fc-next]');
      this.dots = this.querySelector('[data-fc-dots]');
      this.counter = this.querySelector('[data-fc-counter]');
      this.progress = this.querySelector('[data-fc-progress]');
      this.status = this.querySelector('[data-fc-status]');
      this.media = matchMedia('(min-width: 750px)');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.positions = [0];
      this.index = 0;
      const listen = (node, type, fn, options = {}) => {
        if (node) node.addEventListener(type, fn, { ...options, signal: this.events.signal });
      };

      listen(this.prev, 'click', () => this.step(-1));
      listen(this.next, 'click', () => this.step(1));
      listen(this.dots, 'click', event => {
        const button = event.target.closest('[data-fc-dot]');
        if (button) this.go(Number(button.dataset.fcDot));
      });
      listen(this.viewport, 'scroll', () => {
        if (!this.scrollFrame) this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = 0;
          this.update();
        });
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => {
          this.pending = null;
          this.update(true);
        }, 140);
      }, { passive: true });
      listen(this.viewport, 'keydown', event => {
        // Leave buttons, product links and quick-view keyboard controls alone.
        if (event.target !== this.viewport || !this.enabled || this.max < 2) return;
        const forward = this.rtl ? 'ArrowLeft' : 'ArrowRight';
        const backward = this.rtl ? 'ArrowRight' : 'ArrowLeft';
        if (event.key === forward) this.step(1);
        else if (event.key === backward) this.step(-1);
        else if (event.key === 'Home') this.go(0);
        else if (event.key === 'End') this.go(this.positions.length - 1);
        else return;
        event.preventDefault();
      });
      listen(this.viewport, 'focusin', event => {
        if (!this.enabled || this.drag) return;
        const card = event.target.closest('.impressiko-product-card');
        if (!card || card.parentElement !== this.viewport) return;
        const box = card.getBoundingClientRect();
        const frame = this.viewport.getBoundingClientRect();
        if (box.left < frame.left - 2 || box.right > frame.right + 2) {
          const index = this.cards.indexOf(card);
          const target = Math.min(this.max, Math.max(0, this.offsets[index]));
          this.scrollToOffset(target);
        }
      });

      // Touch/pen scrolling remains native, including vertical page movement.
      listen(this.viewport, 'pointerdown', event => {
        if (!this.enabled || this.max < 2 || this.dataset.mouseDrag !== 'true') return;
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        if (event.target.closest('button, input, select, textarea, summary, modal-opener, [role="button"]')) return;
        this.pending = null;
        this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, position: this.position(), moved: false };
      });
      listen(window, 'pointermove', event => {
        const drag = this.drag;
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX - drag.x;
        const dy = event.clientY - drag.y;
        if (!drag.moved) {
          if (Math.abs(dx) < 6) return;
          if (Math.abs(dy) > Math.abs(dx)) { this.drag = null; return; }
          drag.moved = true;
          this.viewport.classList.add('is-fc-dragging');
          try { this.viewport.setPointerCapture(drag.id); } catch (_) { /* Pointer may already be released. */ }
        }
        if (event.cancelable) event.preventDefault();
        this.setPosition(drag.position + (this.rtl ? dx : -dx));
      });
      listen(window, 'pointerup', event => {
        if (this.drag?.id === event.pointerId) this.endDrag(true);
      });
      listen(window, 'pointercancel', event => {
        if (this.drag?.id === event.pointerId) this.endDrag(false);
      });
      listen(this.viewport, 'dragstart', event => {
        if (this.enabled && this.dataset.mouseDrag === 'true') event.preventDefault();
      });
      listen(this.viewport, 'click', event => {
        if (performance.now() < (this.suppressClickUntil || 0)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { capture: true });

      this.lastWidth = -1;
      const scheduleMeasure = () => {
        if (!this.measureFrame) this.measureFrame = requestAnimationFrame(() => {
          this.measureFrame = 0;
          this.measure();
        });
      };
      listen(window, 'resize', scheduleMeasure, { passive: true });
      listen(this.media, 'change', scheduleMeasure);
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => {
          const width = this.viewport.clientWidth;
          if (Math.abs(width - this.lastWidth) > 0.5) scheduleMeasure();
        });
        this.observer.observe(this.viewport);
      }
      this.measure();
    }

    position() {
      const raw = this.rtl ? -this.viewport.scrollLeft : this.viewport.scrollLeft;
      return Math.min(this.max || 0, Math.max(0, raw));
    }

    setPosition(value) {
      const position = Math.max(0, Math.min(this.max, value));
      this.viewport.scrollLeft = this.rtl ? -position : position;
    }

    scrollToOffset(value, smooth = true) {
      const position = Math.max(0, Math.min(this.max, value));
      this.viewport.scrollTo({
        left: this.rtl ? -position : position,
        behavior: smooth && !this.motion.matches ? 'smooth' : 'auto'
      });
    }

    measure() {
      if (!this.isConnected || !this.ready) return;
      this.endDrag(false);
      const oldAnchor = this.anchor || 0;
      const oldEnabled = this.enabled;
      const desktop = this.media.matches;
      this.enabled = (desktop ? this.dataset.desktopSlider : this.dataset.mobileSlider) === 'true';
      this.rtl = getComputedStyle(this.viewport).direction === 'rtl';
      this.lastWidth = this.viewport.clientWidth;
      this.max = Math.max(0, this.viewport.scrollWidth - this.lastWidth);
      const frame = this.viewport.getBoundingClientRect();
      const current = this.position();
      this.offsets = this.cards.map(card => {
        const box = card.getBoundingClientRect();
        return current + (this.rtl ? frame.right - box.right : box.left - frame.left);
      });
      this.positions = [0];
      if (this.enabled && this.max > 2) {
        this.offsets.slice(1).forEach(offset => {
          const value = Math.max(0, Math.min(this.max, offset));
          if (value - this.positions[this.positions.length - 1] > 2) this.positions.push(value);
        });
        if (this.max - this.positions[this.positions.length - 1] > 2) this.positions.push(this.max);
      }
      const overflow = this.enabled && this.max > 2;
      this.dataset.fcOverflow = String(overflow);
      this.viewport.tabIndex = overflow ? 0 : -1;
      this.viewport.setAttribute('aria-label', overflow ? this.dataset.sliderLabel : this.dataset.listLabel);
      const showArrows = overflow && (desktop ? this.dataset.arrowsDesktop : this.dataset.arrowsMobile) === 'true';
      const pagination = desktop ? this.dataset.paginationDesktop : this.dataset.paginationMobile;
      if (this.prev) this.prev.hidden = !showArrows;
      if (this.next) this.next.hidden = !showArrows;
      if (this.counter) this.counter.hidden = !overflow || pagination !== 'counter';
      if (this.progress) this.progress.hidden = !overflow || pagination !== 'progress';
      if (this.dots) this.dots.hidden = !overflow || pagination !== 'dots';
      if (this.controls) this.controls.hidden = !overflow || (!showArrows && pagination === 'none');
      this.pagination = pagination;
      if (this.dots && this.dots.children.length !== this.positions.length) {
        const fragment = document.createDocumentFragment();
        this.positions.forEach((_, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'impressiko-featured__dot';
          button.dataset.fcDot = String(index);
          button.setAttribute('aria-controls', this.viewport.id);
          button.setAttribute('aria-label', `${this.dataset.positionLabel} ${index + 1}`);
          fragment.appendChild(button);
        });
        this.dots.replaceChildren(fragment);
      }
      this.pending = null;
      if (!this.enabled || !oldEnabled) this.setPosition(0);
      else this.setPosition(this.offsets[Math.min(oldAnchor, this.cards.length - 1)] || 0);
      this.update();
    }

    nearest(value) {
      let best = 0;
      let distance = Infinity;
      this.positions.forEach((position, index) => {
        if (Math.abs(position - value) < distance) {
          distance = Math.abs(position - value);
          best = index;
        }
      });
      return best;
    }

    go(index, smooth = true) {
      if (!this.enabled || this.max < 2) return;
      const clamped = Math.max(0, Math.min(this.positions.length - 1, index));
      this.pending = clamped;
      this.scrollToOffset(this.positions[clamped], smooth);
      if (!smooth || this.motion.matches) this.update(true);
    }

    step(direction) {
      const desktop = this.media.matches;
      const columns = Number(desktop ? this.dataset.columnsDesktop : this.dataset.columnsMobile) || 1;
      const jump = this.dataset.scrollStep === 'page' ? Math.max(1, Math.floor(columns)) : 1;
      this.go((this.pending ?? this.nearest(this.position())) + jump * direction);
    }

    endDrag(snap) {
      const drag = this.drag;
      if (!drag) return;
      this.drag = null;
      if (drag.moved) {
        const position = this.position();
        this.suppressClickUntil = performance.now() + 350;
        this.viewport.classList.remove('is-fc-dragging');
        try { this.viewport.releasePointerCapture(drag.id); } catch (_) { /* Already released. */ }
        if (snap && this.dataset.snap === 'true') this.go(this.nearest(position));
      }
    }

    update(announce = false) {
      if (!this.ready) return;
      const value = this.position();
      this.index = this.nearest(value);
      if (this.prev) this.prev.disabled = value <= 2;
      if (this.next) this.next.disabled = value >= this.max - 2;
      if (this.dots) Array.from(this.dots.children).forEach((button, index) => {
        if (index === this.index) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      if (this.progress) {
        const fraction = (this.index + 1) / this.positions.length;
        this.progress.style.setProperty('--fc-progress', String(fraction));
      }
      const visible = [];
      this.offsets.forEach((offset, index) => {
        const width = this.cards[index].getBoundingClientRect().width;
        if (offset + width > value + 2 && offset < value + this.lastWidth - 2) visible.push(index);
      });
      this.anchor = visible[0] || 0;
      const first = this.anchor + 1;
      const last = (visible[visible.length - 1] ?? this.anchor) + 1;
      const range = first === last ? String(first) : `${first}\u2013${last}`;
      if (this.counter) this.counter.textContent = `${range} / ${this.cards.length}`;
      if (announce && this.status) this.status.textContent = `${this.dataset.listLabel}: ${range} / ${this.cards.length}`;
    }
  }
  customElements.define('imp-featured-carousel', ImpFeaturedCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search, [data-impressiko-live-search]');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
      this.customSearches = this.customSearches || this.header.querySelectorAll('[data-impressiko-live-search]');
      this.customSearches.forEach((search) => search._impressikoSearchClose?.());
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    

/* Native-scroll carousel. No product clones or changes to Dawn's quick-add flow. */
if (!customElements.get('imp-collection-carousel')) {
  class ImpCollectionCarousel extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.init());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.measureFrame);
      cancelAnimationFrame(this.scrollFrame);
      clearTimeout(this.settleTimer);
      this.events?.abort();
      this.observer?.disconnect();
      this.endDrag(false);
      this.ready = false;
    }

    init() {
      if (this.ready || !this.isConnected) return;
      this.viewport = this.querySelector('[data-fc-track]');
      if (!this.viewport) return;
      this.cards = Array.from(this.viewport.children).filter(node => node.matches('.impressiko-product-card'));
      if (!this.cards.length) return;
      this.ready = true;
      this.events = new AbortController();
      this.controls = this.querySelector('[data-fc-controls]');
      this.prev = this.querySelector('[data-fc-prev]');
      this.next = this.querySelector('[data-fc-next]');
      this.dots = this.querySelector('[data-fc-dots]');
      this.counter = this.querySelector('[data-fc-counter]');
      this.progress = this.querySelector('[data-fc-progress]');
      this.status = this.querySelector('[data-fc-status]');
      this.media = matchMedia('(min-width: 750px)');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.positions = [0];
      this.index = 0;
      const listen = (node, type, fn, options = {}) => {
        if (node) node.addEventListener(type, fn, { ...options, signal: this.events.signal });
      };

      listen(this.prev, 'click', () => this.step(-1));
      listen(this.next, 'click', () => this.step(1));
      listen(this.dots, 'click', event => {
        const button = event.target.closest('[data-fc-dot]');
        if (button) this.go(Number(button.dataset.fcDot));
      });
      listen(this.viewport, 'scroll', () => {
        if (!this.scrollFrame) this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = 0;
          this.update();
        });
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => {
          this.pending = null;
          this.update(true);
        }, 140);
      }, { passive: true });
      listen(this.viewport, 'keydown', event => {
        // Leave buttons, product links and quick-view keyboard controls alone.
        if (event.target !== this.viewport || !this.enabled || this.max < 2) return;
        const forward = this.rtl ? 'ArrowLeft' : 'ArrowRight';
        const backward = this.rtl ? 'ArrowRight' : 'ArrowLeft';
        if (event.key === forward) this.step(1);
        else if (event.key === backward) this.step(-1);
        else if (event.key === 'Home') this.go(0);
        else if (event.key === 'End') this.go(this.positions.length - 1);
        else return;
        event.preventDefault();
      });
      listen(this.viewport, 'focusin', event => {
        if (!this.enabled || this.drag) return;
        const card = event.target.closest('.impressiko-product-card');
        if (!card || card.parentElement !== this.viewport) return;
        const box = card.getBoundingClientRect();
        const frame = this.viewport.getBoundingClientRect();
        if (box.left < frame.left - 2 || box.right > frame.right + 2) {
          const index = this.cards.indexOf(card);
          const target = Math.min(this.max, Math.max(0, this.offsets[index]));
          this.scrollToOffset(target);
        }
      });

      // Touch/pen scrolling remains native, including vertical page movement.
      listen(this.viewport, 'pointerdown', event => {
        if (!this.enabled || this.max < 2 || this.dataset.mouseDrag !== 'true') return;
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        if (event.target.closest('button, input, select, textarea, summary, modal-opener, .impressiko-product-card__button, [role="button"]')) return;
        this.pending = null;
        this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, position: this.position(), moved: false };
      });
      listen(window, 'pointermove', event => {
        const drag = this.drag;
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX - drag.x;
        const dy = event.clientY - drag.y;
        if (!drag.moved) {
          if (Math.abs(dx) < 6) return;
          if (Math.abs(dy) > Math.abs(dx)) { this.drag = null; return; }
          drag.moved = true;
          this.viewport.classList.add('is-fc-dragging');
          try { this.viewport.setPointerCapture(drag.id); } catch (_) { /* Pointer may already be released. */ }
        }
        if (event.cancelable) event.preventDefault();
        this.setPosition(drag.position + (this.rtl ? dx : -dx));
      });
      listen(window, 'pointerup', event => {
        if (this.drag?.id === event.pointerId) this.endDrag(true);
      });
      listen(window, 'pointercancel', event => {
        if (this.drag?.id === event.pointerId) this.endDrag(false);
      });
      listen(this.viewport, 'dragstart', event => {
        if (this.enabled && this.dataset.mouseDrag === 'true') event.preventDefault();
      });
      listen(this.viewport, 'click', event => {
        if (performance.now() < (this.suppressClickUntil || 0)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { capture: true });

      this.lastWidth = -1;
      const scheduleMeasure = () => {
        if (!this.measureFrame) this.measureFrame = requestAnimationFrame(() => {
          this.measureFrame = 0;
          this.measure();
        });
      };
      listen(window, 'resize', scheduleMeasure, { passive: true });
      listen(this.media, 'change', scheduleMeasure);
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => {
          const width = this.viewport.clientWidth;
          if (Math.abs(width - this.lastWidth) > 0.5) scheduleMeasure();
        });
        this.observer.observe(this.viewport);
      }
      this.measure();
    }

    position() {
      const raw = this.rtl ? -this.viewport.scrollLeft : this.viewport.scrollLeft;
      return Math.min(this.max || 0, Math.max(0, raw));
    }

    setPosition(value) {
      const position = Math.max(0, Math.min(this.max, value));
      this.viewport.scrollLeft = this.rtl ? -position : position;
    }

    scrollToOffset(value, smooth = true) {
      const position = Math.max(0, Math.min(this.max, value));
      this.viewport.scrollTo({
        left: this.rtl ? -position : position,
        behavior: smooth && !this.motion.matches ? 'smooth' : 'auto'
      });
    }

    measure() {
      if (!this.isConnected || !this.ready) return;
      this.endDrag(false);
      const oldAnchor = this.anchor || 0;
      const oldEnabled = this.enabled;
      const desktop = this.media.matches;
      this.enabled = (desktop ? this.dataset.desktopSlider : this.dataset.mobileSlider) === 'true';
      this.rtl = getComputedStyle(this.viewport).direction === 'rtl';
      this.lastWidth = this.viewport.clientWidth;
      this.max = Math.max(0, this.viewport.scrollWidth - this.lastWidth);
      const frame = this.viewport.getBoundingClientRect();
      const current = this.position();
      this.offsets = this.cards.map(card => {
        const box = card.getBoundingClientRect();
        return current + (this.rtl ? frame.right - box.right : box.left - frame.left);
      });
      this.positions = [0];
      if (this.enabled && this.max > 2) {
        this.offsets.slice(1).forEach(offset => {
          const value = Math.max(0, Math.min(this.max, offset));
          if (value - this.positions[this.positions.length - 1] > 2) this.positions.push(value);
        });
        if (this.max - this.positions[this.positions.length - 1] > 2) this.positions.push(this.max);
      }
      const overflow = this.enabled && this.max > 2;
      this.dataset.fcOverflow = String(overflow);
      this.viewport.tabIndex = overflow ? 0 : -1;
      this.viewport.setAttribute('aria-label', overflow ? this.dataset.sliderLabel : this.dataset.listLabel);
      const showArrows = overflow && (desktop ? this.dataset.arrowsDesktop : this.dataset.arrowsMobile) === 'true';
      const pagination = desktop ? this.dataset.paginationDesktop : this.dataset.paginationMobile;
      if (this.prev) this.prev.hidden = !showArrows;
      if (this.next) this.next.hidden = !showArrows;
      if (this.counter) this.counter.hidden = !overflow || pagination !== 'counter';
      if (this.progress) this.progress.hidden = !overflow || pagination !== 'progress';
      if (this.dots) this.dots.hidden = !overflow || pagination !== 'dots';
      if (this.controls) this.controls.hidden = !overflow || (!showArrows && pagination === 'none');
      this.pagination = pagination;
      if (this.dots && this.dots.children.length !== this.positions.length) {
        const fragment = document.createDocumentFragment();
        this.positions.forEach((_, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'impressiko-featured__dot';
          button.dataset.fcDot = String(index);
          button.setAttribute('aria-controls', this.viewport.id);
          button.setAttribute('aria-label', `${this.dataset.positionLabel} ${index + 1}`);
          fragment.appendChild(button);
        });
        this.dots.replaceChildren(fragment);
      }
      this.pending = null;
      if (!this.enabled || !oldEnabled) this.setPosition(0);
      else this.setPosition(this.offsets[Math.min(oldAnchor, this.cards.length - 1)] || 0);
      this.update();
    }

    nearest(value) {
      let best = 0;
      let distance = Infinity;
      this.positions.forEach((position, index) => {
        if (Math.abs(position - value) < distance) {
          distance = Math.abs(position - value);
          best = index;
        }
      });
      return best;
    }

    go(index, smooth = true) {
      if (!this.enabled || this.max < 2) return;
      const clamped = Math.max(0, Math.min(this.positions.length - 1, index));
      this.pending = clamped;
      this.scrollToOffset(this.positions[clamped], smooth);
      if (!smooth || this.motion.matches) this.update(true);
    }

    step(direction) {
      const desktop = this.media.matches;
      const columns = Number(desktop ? this.dataset.columnsDesktop : this.dataset.columnsMobile) || 1;
      const jump = this.dataset.scrollStep === 'page' ? Math.max(1, Math.floor(columns)) : 1;
      this.go((this.pending ?? this.nearest(this.position())) + jump * direction);
    }

    endDrag(snap) {
      const drag = this.drag;
      if (!drag) return;
      this.drag = null;
      if (drag.moved) {
        const position = this.position();
        this.suppressClickUntil = performance.now() + 350;
        this.viewport.classList.remove('is-fc-dragging');
        try { this.viewport.releasePointerCapture(drag.id); } catch (_) { /* Already released. */ }
        if (snap && this.dataset.snap === 'true') this.go(this.nearest(position));
      }
    }

    update(announce = false) {
      if (!this.ready) return;
      const value = this.position();
      this.index = this.nearest(value);
      if (this.prev) this.prev.disabled = value <= 2;
      if (this.next) this.next.disabled = value >= this.max - 2;
      if (this.dots) Array.from(this.dots.children).forEach((button, index) => {
        if (index === this.index) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      if (this.progress) {
        const fraction = (this.index + 1) / this.positions.length;
        this.progress.style.setProperty('--fc-progress', String(fraction));
      }
      const visible = [];
      this.offsets.forEach((offset, index) => {
        const width = this.cards[index].getBoundingClientRect().width;
        if (offset + width > value + 2 && offset < value + this.lastWidth - 2) visible.push(index);
      });
      this.anchor = visible[0] || 0;
      const first = this.anchor + 1;
      const last = (visible[visible.length - 1] ?? this.anchor) + 1;
      const range = first === last ? String(first) : `${first}\u2013${last}`;
      if (this.counter) this.counter.textContent = `${range} / ${this.cards.length}`;
      if (announce && this.status) this.status.textContent = `${this.dataset.listLabel}: ${range} / ${this.cards.length}`;
    }
  }
  customElements.define('imp-collection-carousel', ImpCollectionCarousel);
}

/* One lazy Dawn quick view per collection. Survives facets replacing only the grid.
 * Product URLs remain normal links when scripts are unavailable.
 */
if (!customElements.get('imp-collection-modal-host')) {
  class ImpCollectionModalHost extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.init());
    }
    init() {
      if (this.events || !this.isConnected) return;
      this.events = new AbortController();
      this.scope = this.closest('.shopify-section');
      this.template = this.querySelector('[data-cgp-modal-template]');
      this.status = this.querySelector('[data-cgp-modal-status]');
      if (!this.scope || !this.template) return;
      this.scope.addEventListener('click', (event) => {
        const link = event.target.closest('a[data-cgp-open]');
        if (!link || link.dataset.cgpOpen !== this.dataset.sectionId) return;
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        // Fall back to the product page rather than display a broken dialog.
        const NativeQuickAdd = customElements.get('quick-add-modal');
        if (!NativeQuickAdd || typeof HTMLUpdateUtility === 'undefined') return;
        event.preventDefault();
        this.open(link, NativeQuickAdd);
      }, { signal: this.events.signal });
    }
    getModal() {
      if (this.modal?.isConnected) return this.modal;
      const modal = this.template.content.querySelector('quick-add-modal');
      if (!modal) return null;
      const fragment = document.importNode(this.template.content, true);
      this.modal = fragment.querySelector('quick-add-modal');
      // Let Dawn's connectedCallback assign its section and portal to body.
      this.appendChild(fragment);
      return this.modal;
    }
    setBusy(link, busy) {
      if (!link) return;
      link.classList.toggle('loading', busy);
      if (busy) { link.setAttribute('aria-disabled', 'true'); link.setAttribute('aria-busy', 'true'); }
      else { link.removeAttribute('aria-disabled'); link.removeAttribute('aria-busy'); }
      link.querySelector('.loading__spinner')?.classList.toggle('hidden', !busy);
    }
    async open(link, NativeQuickAdd) {
      this.request?.abort();
      this.setBusy(this.opener, false);
      const request = new AbortController();
      this.request = request;
      this.opener = link;
      this.setBusy(link, true);
      if (this.status) this.status.textContent = '';
      const url = link.getAttribute('href');
      try {
        const response = await fetch(url, { signal: request.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Product response was not successful.');
        const html = await response.text();
        if (!this.isConnected || !link.isConnected || request.signal.aborted) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const product = doc.querySelector('product-info');
        if (!product) throw new Error('Product information was not found.');
        const modal = this.getModal();
        if (!modal || typeof modal.preprocessHTML !== 'function') throw new Error('Quick view is not compatible.');
        // Reuse Dawn's media, option-selection and duplicate-ID preprocessing.
        modal.preprocessHTML(product);
        HTMLUpdateUtility.setInnerHTML(modal.modalContent, product.outerHTML);
        if (request.signal.aborted || !this.isConnected || !link.isConnected) return;
        modal.querySelector('[role="dialog"]')?.setAttribute('aria-label', link.closest('.impressiko-product-card')?.querySelector('.impressiko-product-card__title')?.textContent.trim() || 'Product options');
        const BaseDialog = Object.getPrototypeOf(NativeQuickAdd.prototype);
        if (typeof BaseDialog.show !== 'function') throw new Error('Dialog support unavailable.');
        // Call only the base dialog show: NativeQuickAdd.show would fetch twice.
        BaseDialog.show.call(modal, link);
        window.Shopify?.PaymentButton?.init?.();
        window.ProductModel?.loadShopifyXR?.();
        modal.modalContent.querySelector('product-component')?.dispatchViewEvent?.();
      } catch (error) {
        if (error.name === 'AbortError' || request.signal.aborted || !this.isConnected || !link.isConnected) return;
        if (this.status) this.status.textContent = this.dataset.errorMessage;
        // The original product URL is the safe functional fallback on network/theme errors.
        window.location.assign(url);
      } finally {
        if (this.request === request) {
          this.setBusy(link, false);
          this.request = null;
        }
      }
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      this.events?.abort();
      this.events = null;
      this.request?.abort();
      this.request = null;
      this.setBusy(this.opener, false);
      if (this.modal) {
        if (this.modal.hasAttribute('open')) this.modal.hide(true);
        this.modal.remove();
        this.modal = null;
      }
    }
  }
  customElements.define('imp-collection-modal-host', ImpCollectionModalHost);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
/* Measurements only on layout changes. Native CSS sticky owns scrolling. */
if (!customElements.get('imp-sticky-gallery-v2')) {
customElements.define('imp-sticky-gallery-v2', class extends HTMLElement {
connectedCallback() {
if (this._connected) return;
this._connected = true;
this._values = new Map();
this._width = 0;
this._headerHeight = 0;
this._mobileViewport = 0;
this._abort = new AbortController();
const options = { signal: this._abort.signal };
this._schedule = () => {
if (this._frame || !this.isConnected) return;
this._frame = requestAnimationFrame(() => {
this._frame = 0;
if (this._connected) this._measure();
});
};
window.addEventListener('resize', this._schedule, { ...options, passive: true });
this.addEventListener('load', this._schedule, { ...options, capture: true });
if ('ResizeObserver' in window) {
this._resize = new ResizeObserver(this._schedule);
this._resize.observe(this);
}
this._mutations = new MutationObserver(this._schedule);
this._mutations.observe(this, { childList: true, subtree: true });
if (document.fonts && document.fonts.ready) {
document.fonts.ready.then(() => { if (this._connected) this._schedule(); });
}
this._installMobileNavigation();
this._schedule();
}
disconnectedCallback() {
this._connected = false;
this._abort?.abort();
this._resize?.disconnect();
this._mutations?.disconnect();
cancelAnimationFrame(this._frame);
this._frame = 0;
this._watchedHeader = null;
if (this._mediaGallery?.setActiveMedia === this._mobileSetActive) {
  this._mediaGallery.setActiveMedia = this._originalSetActive;
}
this._mediaGallery = null;
cancelAnimationFrame(this._mobileScrollFrame);
}
_number(value, fallback = 0) {
const parsed = Number(value);
return Number.isFinite(parsed) ? parsed : fallback;
}
_set(name, value) {
value = Math.round(value * 10) / 10;
if (this._values.get(name) === value) return;
this._values.set(name, value);
this.style.setProperty(name, value + 'px');
}
_flag(name, value) {
const next = value ? 'true' : 'false';
if (this.dataset[name] !== next) this.dataset[name] = next;
}

_installMobileNavigation() {
  customElements.whenDefined('media-gallery').then(() => {
    if (!this._connected || !this.isConnected) return;
    const gallery = this.querySelector('media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;
    this._mediaGallery = gallery;
    this._originalSetActive = gallery.setActiveMedia;
    const original = this._originalSetActive;
    this._mobileSetActive = (mediaId, prepend) => {
      if (!window.matchMedia('(max-width: 749px)').matches) {
        return original.call(gallery, mediaId, prepend);
      }
      const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
      const slides = Array.from(viewer?.querySelectorAll('.product__media-item[data-media-id]') || []);
      const target = slides.find(item => item.dataset.mediaId === String(mediaId)) || slides[0];
      if (!target) return;
      slides.forEach(item => item.classList.toggle('is-active', item === target));
      if (prepend && target.parentElement.firstElementChild !== target) {
        target.parentElement.prepend(target);
        const thumbnails = gallery.querySelector('[id^="GalleryThumbnails-"]');
        const selected = Array.from(thumbnails?.querySelectorAll('[data-target]') || []).find(item => item.dataset.target === String(mediaId));
        if (selected) selected.parentElement.prepend(selected);
        viewer.resetPages?.();
      }
      const list = target.parentElement;
      const left = target.getBoundingClientRect().left - list.getBoundingClientRect().left + list.scrollLeft;
      list.scrollTo({ left, behavior: 'instant' });
      gallery.playActiveMedia?.(target);
      const nativeThumb = Array.from(gallery.querySelectorAll('[data-target]')).find(item => item.dataset.target === target.dataset.mediaId);
      if (nativeThumb) {
        gallery.setActiveThumbnail?.(nativeThumb);
        if (nativeThumb.dataset.mediaPosition) gallery.announceLiveRegion?.(target, nativeThumb.dataset.mediaPosition);
      }
      this._syncMobileSelection(target);
    };
    gallery.setActiveMedia = this._mobileSetActive;
    // Scroll events do not bubble; capture the actual horizontal media list.
    this.addEventListener('scroll', event => {
      if (!window.matchMedia('(max-width: 749px)').matches ||
          !event.target.matches?.('.product__media-list') || this._mobileScrollFrame) return;
      this._mobileScrollFrame = requestAnimationFrame(() => {
        this._mobileScrollFrame = 0;
        if (!this._connected) return;
        const list = this.querySelector('[id^="GalleryViewer-"] .product__media-list');
        if (!list) return;
        const center = list.getBoundingClientRect().left + list.clientWidth / 2;
        const slides = Array.from(list.querySelectorAll('.product__media-item[data-media-id]')).filter(item => item.getClientRects().length);
        let nearest = null, distance = Infinity;
        slides.forEach(item => {
          const rect = item.getBoundingClientRect();
          const next = Math.abs(rect.left + rect.width / 2 - center);
          if (next < distance) { distance = next; nearest = item; }
        });
        if (!nearest) return;
        slides.forEach(item => item.classList.toggle('is-active', item === nearest));
        this._syncMobileSelection(nearest);
      });
    }, { capture: true, passive: true, signal: this._abort.signal });
  });
}
_syncMobileSelection(slide) {
  const track = this.querySelector('[data-custom-thumb-track]');
  let selected = null;
  this.querySelectorAll('[data-custom-thumb]').forEach(button => {
    const active = button.dataset.mediaId === slide.dataset.mediaId;
    const value = active ? 'true' : 'false';
    if (button.getAttribute('aria-current') !== value) button.setAttribute('aria-current', value);
    if (active) selected = button;
  });
  if (selected && track) {
    const left = selected.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    track.scrollTo({ left: Math.max(0, left - (track.clientWidth - selected.offsetWidth) / 2), behavior: 'instant' });
  }
  this.dispatchEvent(new CustomEvent('imp:mobile-media-change', { bubbles: true, detail: { mediaId: slide.dataset.mediaId } }));
}

_measure() {
const mobile = window.matchMedia('(max-width: 749px)').matches;
const active = !mobile && this._number(this.dataset.mediaCount) > 0 &&
this.dataset.stickyDesktop === 'true' &&
!this.closest('quick-add-modal, dialog, [role="dialog"]');
this._flag('igActive', active);
if (!active) { this._flag('igFit', false); return; }

const width = document.documentElement.clientWidth;
if (Math.abs(width - this._width) > 1) {
this._width = width;
this._headerHeight = 0;
this._mobileViewport = window.innerHeight;
}
const viewport = mobile ? this._mobileViewport : window.innerHeight;
const manual = this._number(mobile ? this.dataset.topMobile : this.dataset.topDesktop, 80);
let headerSpace = manual;
if (this.dataset.headerMode === 'auto') {
const header = document.querySelector('sticky-header') || document.querySelector('.section-header');
if (header !== this._watchedHeader) {
if (this._watchedHeader) this._resize?.unobserve(this._watchedHeader);
this._watchedHeader = header;
if (header) this._resize?.observe(header);
}
if (header) {
const host = header.closest('.shopify-section') || header;
const mode = header.dataset.stickyType;
const hostStyle = getComputedStyle(host);
const ownStyle = getComputedStyle(header);
const persistent = mode ? mode !== 'none' :
[hostStyle.position, ownStyle.position].some(p => p === 'sticky' || p === 'fixed');
if (persistent) {
const height = Math.max(host.offsetHeight, header.offsetHeight);
const top = Math.max(0, parseFloat(hostStyle.top) || 0, parseFloat(ownStyle.top) || 0);
// Do not follow scroll-up hiding or a shrinking-logo animation.
this._headerHeight = Math.max(this._headerHeight, height + top);
headerSpace = this._headerHeight;
} else headerSpace = 0;
} else headerSpace = 0;
}
const top = Math.max(0, headerSpace + this._number(this.dataset.headerGap, 12));
const remaining = Math.max(60, viewport - top - this._number(this.dataset.bottomGap, 24));
const share = Math.max(20, Math.min(50, this._number(this.dataset.mobileShare, 38)));
const budget = mobile ? Math.min(remaining, viewport * share / 100) : remaining;
this._set('--ig-top', top);
this._set('--ig-budget', budget);

const layout = mobile ? this.dataset.mobileMode : this.dataset.desktopMode;
const fit = this.dataset.stickyFit === 'true' && ['single', 'peek'].includes(layout);
this._flag('igFit', fit);
if (!fit) return;
const thumbs = this.querySelector('[data-custom-product-thumbnails]');
let thumbnailHeight = 0;
if (thumbs && getComputedStyle(thumbs).display !== 'none') {
const style = getComputedStyle(thumbs);
thumbnailHeight = thumbs.getBoundingClientRect().height +
(parseFloat(style.marginTop) || 0) + (parseFloat(style.marginBottom) || 0);
}
const style = getComputedStyle(this);
const padding = (parseFloat(style.paddingTop) || 0) + (parseFloat(style.paddingBottom) || 0);
const slide = this.querySelector('.product__media-item');
const stage = this.querySelector('.custom-product-gallery__stage');
const mediaWidth = (slide || stage || this).getBoundingClientRect().width;
const ratio = Math.max(0.05, this._number(this.dataset.previewRatio, 1));
const cap = Math.max(40, budget - thumbnailHeight - padding - 2);
this._set('--ig-main-height', Math.min(mediaWidth / ratio, cap));
}
});
}

/* Mobile preview has its own normal-flow slot inside the information column.
   Native sticky provides section-end release. No fixed overlays or y-scrollers. */
if (!customElements.get('imp-mobile-product-preview')) {
  customElements.define('imp-mobile-product-preview', class extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._root = this.closest('product-info');
      this._gallery = this._root?.querySelector('[data-custom-product-gallery]');
      if (!this._root || !this._gallery) return;
      this._abort = new AbortController();
      this._stableWidth = 0;
      this._lastTop = -1;
      const options = { signal: this._abort.signal };
      this._schedule = () => {
        if (this._frame || !this.isConnected) return;
        this._frame = requestAnimationFrame(() => {
          this._frame = 0;
          if (!this._connected || !matchMedia('(max-width: 749px)').matches) return;
          this._measureHeader();
        });
      };
      window.addEventListener('scroll', this._schedule, { ...options, passive: true });
      window.addEventListener('resize', this._schedule, { ...options, passive: true });
      this._root.addEventListener('imp:mobile-media-change', () => this._syncImage(), options);
      this.querySelector('a')?.addEventListener('click', event => {
        event.preventDefault();
        const stage = this._gallery.querySelector('.custom-product-gallery__stage');
        if (!stage) return;
        this._measureHeader();
        // Reserve the full header before scrolling back up, since it may reveal.
        const header = document.querySelector('sticky-header') || document.querySelector('.section-header');
        const host = header?.closest('.shopify-section') || header;
        const space = Math.max(this._lastTop, this._persistentHeader ? (host?.offsetHeight || 0) + (Number(this.dataset.headerGap) || 0) : 0);
        window.scrollTo({ top: Math.max(0, stage.getBoundingClientRect().top + window.scrollY - space), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, options);
      this._observer = new MutationObserver(() => this._syncImage());
      this._observer.observe(this._gallery, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-current', 'class', 'src', 'srcset'] });
      if ('ResizeObserver' in window) {
        this._headerObserver = new ResizeObserver(this._schedule);
        const header = document.querySelector('sticky-header') || document.querySelector('.section-header');
        if (header) this._headerObserver.observe(header);
      }
      this._syncImage();
      this._schedule();
    }
    disconnectedCallback() {
      this._connected = false;
      this._abort?.abort();
      this._observer?.disconnect();
      this._headerObserver?.disconnect();
      cancelAnimationFrame(this._frame);
      this._frame = 0;
    }
    _syncImage() {
      const image = this.querySelector('.imp-mobile-preview__image');
      if (!image || !this._gallery) return;
      const thumb = this._gallery.querySelector('[data-custom-thumb][aria-current="true"] img');
      const active = this._gallery.querySelector('.product__media-item.is-active .product__media img');
      const source = thumb || active;
      if (!source) return;
      const src = source.currentSrc || source.src;
      if (!src || image.getAttribute('src') === src) return;
      // Fixed dimensions prevent layout shifts when the selected image changes.
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = src;
    }
    _measureHeader() {
      let top = 0;
      const gap = Math.max(0, Number(this.dataset.headerGap) || 0);
      const header = document.querySelector('sticky-header') || document.querySelector('.section-header');
      this._persistentHeader = false;
      if (this.dataset.headerMode === 'manual') {
        top = Math.max(0, Number(this.dataset.topMobile) || 0);
      } else if (header) {
        const host = header.closest('.shopify-section') || header;
        const hs = getComputedStyle(host), own = getComputedStyle(header);
        const mode = header.dataset.stickyType;
        this._persistentHeader = mode ? mode !== 'none' : [hs.position, own.position].some(value => value === 'sticky' || value === 'fixed');
        if (this._persistentHeader) {
          const rect = host.getBoundingClientRect();
          const visible = hs.visibility !== 'hidden' && hs.display !== 'none';
          if (visible && rect.top < window.innerHeight && rect.bottom > 0) {
            // Only reserve the visible header; hiding a scroll-up header leaves
            // no tall blank space. The gallery's size is never changed here.
            top = Math.min(rect.bottom, host.offsetHeight + Math.max(0, parseFloat(hs.top) || 0));
          }
        }
      }
      const nextTop = Math.round(Math.max(0, top) + gap);
      if (nextTop !== this._lastTop) {
        this._lastTop = nextTop;
        this.style.setProperty('--mp-top', nextTop + 'px');
      }
      const width = document.documentElement.clientWidth;
      if (Math.abs(width - this._stableWidth) > 1) {
        this._stableWidth = width;
        const share = Math.max(20, Math.min(50, Number(this.dataset.heightShare) || 38));
        const limit = Math.max(32, Math.min(120, window.innerHeight * share / 100 - 18));
        this.style.setProperty('--mp-image-limit', limit + 'px');
      }
    }
  });
}



/* Lightweight accessible perfume notes tabs. */
if (!customElements.get('imp-notes-tabs')) {
  customElements.define('imp-notes-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this._tabs = Array.from(this.querySelectorAll('[data-notes-tab]'));
      this._panels = Array.from(this.querySelectorAll('[data-notes-panel]'));
      if (!this._tabs.length || !this._panels.length) return;

      this._activate = (index, focus = false) => {
        const key = String(index);
        this._tabs.forEach((tab) => {
          const active = tab.dataset.notesTab === key;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          if (active && focus) tab.focus({ preventScroll: true });
        });
        this._panels.forEach((panel) => {
          panel.hidden = panel.dataset.notesPanel !== key;
        });
      };

      /* Theme Editor option: either open the first tab on load or keep the
         complete notes area collapsed until the customer chooses a tab. */
      const openFirstTab = this.dataset.firstTabOpen === 'true';
      if (openFirstTab) {
        this._activate(this._tabs[0].dataset.notesTab);
      } else {
        this._tabs.forEach((tab, index) => {
          tab.classList.remove('is-active');
          tab.setAttribute('aria-selected', 'false');
          tab.tabIndex = index === 0 ? 0 : -1;
        });
        this._panels.forEach((panel) => { panel.hidden = true; });
      }

      this._tabs.forEach((tab, tabIndex) => {
        tab.addEventListener('click', () => this._activate(tab.dataset.notesTab));
        tab.addEventListener('keydown', (event) => {
          let next = null;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (tabIndex + 1) % this._tabs.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (tabIndex - 1 + this._tabs.length) % this._tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this._tabs.length - 1;
          if (next === null) return;
          event.preventDefault();
          this._activate(this._tabs[next].dataset.notesTab, true);
        });
      });
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
/* Native-scroll carousel. No product clones or changes to Dawn's quick-add flow. */
if (!customElements.get('imp-featured-carousel')) {
  class ImpFeaturedCarousel extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.init());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.measureFrame);
      cancelAnimationFrame(this.scrollFrame);
      clearTimeout(this.settleTimer);
      this.events?.abort();
      this.observer?.disconnect();
      this.endDrag(false);
      this.ready = false;
    }

    init() {
      if (this.ready || !this.isConnected) return;
      this.viewport = this.querySelector('[data-fc-track]');
      if (!this.viewport) return;
      this.cards = Array.from(this.viewport.children).filter(node => node.matches('.impressiko-product-card'));
      if (!this.cards.length) return;
      this.ready = true;
      this.events = new AbortController();
      this.controls = this.querySelector('[data-fc-controls]');
      this.prev = this.querySelector('[data-fc-prev]');
      this.next = this.querySelector('[data-fc-next]');
      this.dots = this.querySelector('[data-fc-dots]');
      this.counter = this.querySelector('[data-fc-counter]');
      this.progress = this.querySelector('[data-fc-progress]');
      this.status = this.querySelector('[data-fc-status]');
      this.media = matchMedia('(min-width: 750px)');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.positions = [0];
      this.index = 0;
      const listen = (node, type, fn, options = {}) => {
        if (node) node.addEventListener(type, fn, { ...options, signal: this.events.signal });
      };

      listen(this.prev, 'click', () => this.step(-1));
      listen(this.next, 'click', () => this.step(1));
      listen(this.dots, 'click', event => {
        const button = event.target.closest('[data-fc-dot]');
        if (button) this.go(Number(button.dataset.fcDot));
      });
      listen(this.viewport, 'scroll', () => {
        if (!this.scrollFrame) this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = 0;
          this.update();
        });
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => {
          this.pending = null;
          this.update(true);
        }, 140);
      }, { passive: true });
      listen(this.viewport, 'keydown', event => {
        // Leave buttons, product links and quick-view keyboard controls alone.
        if (event.target !== this.viewport || !this.enabled || this.max < 2) return;
        const forward = this.rtl ? 'ArrowLeft' : 'ArrowRight';
        const backward = this.rtl ? 'ArrowRight' : 'ArrowLeft';
        if (event.key === forward) this.step(1);
        else if (event.key === backward) this.step(-1);
        else if (event.key === 'Home') this.go(0);
        else if (event.key === 'End') this.go(this.positions.length - 1);
        else return;
        event.preventDefault();
      });
      listen(this.viewport, 'focusin', event => {
        if (!this.enabled || this.drag) return;
        const card = event.target.closest('.impressiko-product-card');
        if (!card || card.parentElement !== this.viewport) return;
        const box = card.getBoundingClientRect();
        const frame = this.viewport.getBoundingClientRect();
        if (box.left < frame.left - 2 || box.right > frame.right + 2) {
          const index = this.cards.indexOf(card);
          const target = Math.min(this.max, Math.max(0, this.offsets[index]));
          this.scrollToOffset(target);
        }
      });

      // Touch/pen scrolling remains native, including vertical page movement.
      listen(this.viewport, 'pointerdown', event => {
        if (!this.enabled || this.max < 2 || this.dataset.mouseDrag !== 'true') return;
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        if (event.target.closest('button, input, select, textarea, summary, modal-opener, [role="button"]')) return;
        this.pending = null;
        this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, position: this.position(), moved: false };
      });
      listen(window, 'pointermove', event => {
        const drag = this.drag;
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX - drag.x;
        const dy = event.clientY - drag.y;
        if (!drag.moved) {
          if (Math.abs(dx) < 6) return;
          if (Math.abs(dy) > Math.abs(dx)) { this.drag = null; return; }
          drag.moved = true;
          this.viewport.classList.add('is-fc-dragging');
          try { this.viewport.setPointerCapture(drag.id); } catch (_) { /* Pointer may already be released. */ }
        }
        if (event.cancelable) event.preventDefault();
        this.setPosition(drag.position + (this.rtl ? dx : -dx));
      });
      listen(window, 'pointerup', event => {
        if (this.drag?.id === event.pointerId) this.endDrag(true);
      });
      listen(window, 'pointercancel', event => {
        if (this.drag?.id === event.pointerId) this.endDrag(false);
      });
      listen(this.viewport, 'dragstart', event => {
        if (this.enabled && this.dataset.mouseDrag === 'true') event.preventDefault();
      });
      listen(this.viewport, 'click', event => {
        if (performance.now() < (this.suppressClickUntil || 0)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { capture: true });

      this.lastWidth = -1;
      const scheduleMeasure = () => {
        if (!this.measureFrame) this.measureFrame = requestAnimationFrame(() => {
          this.measureFrame = 0;
          this.measure();
        });
      };
      listen(window, 'resize', scheduleMeasure, { passive: true });
      listen(this.media, 'change', scheduleMeasure);
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => {
          const width = this.viewport.clientWidth;
          if (Math.abs(width - this.lastWidth) > 0.5) scheduleMeasure();
        });
        this.observer.observe(this.viewport);
      }
      this.measure();
    }

    position() {
      const raw = this.rtl ? -this.viewport.scrollLeft : this.viewport.scrollLeft;
      return Math.min(this.max || 0, Math.max(0, raw));
    }

    setPosition(value) {
      const position = Math.max(0, Math.min(this.max, value));
      this.viewport.scrollLeft = this.rtl ? -position : position;
    }

    scrollToOffset(value, smooth = true) {
      const position = Math.max(0, Math.min(this.max, value));
      this.viewport.scrollTo({
        left: this.rtl ? -position : position,
        behavior: smooth && !this.motion.matches ? 'smooth' : 'auto'
      });
    }

    measure() {
      if (!this.isConnected || !this.ready) return;
      this.endDrag(false);
      const oldAnchor = this.anchor || 0;
      const oldEnabled = this.enabled;
      const desktop = this.media.matches;
      this.enabled = (desktop ? this.dataset.desktopSlider : this.dataset.mobileSlider) === 'true';
      this.rtl = getComputedStyle(this.viewport).direction === 'rtl';
      this.lastWidth = this.viewport.clientWidth;
      this.max = Math.max(0, this.viewport.scrollWidth - this.lastWidth);
      const frame = this.viewport.getBoundingClientRect();
      const current = this.position();
      this.offsets = this.cards.map(card => {
        const box = card.getBoundingClientRect();
        return current + (this.rtl ? frame.right - box.right : box.left - frame.left);
      });
      this.positions = [0];
      if (this.enabled && this.max > 2) {
        this.offsets.slice(1).forEach(offset => {
          const value = Math.max(0, Math.min(this.max, offset));
          if (value - this.positions[this.positions.length - 1] > 2) this.positions.push(value);
        });
        if (this.max - this.positions[this.positions.length - 1] > 2) this.positions.push(this.max);
      }
      const overflow = this.enabled && this.max > 2;
      this.dataset.fcOverflow = String(overflow);
      this.viewport.tabIndex = overflow ? 0 : -1;
      this.viewport.setAttribute('aria-label', overflow ? this.dataset.sliderLabel : this.dataset.listLabel);
      const showArrows = overflow && (desktop ? this.dataset.arrowsDesktop : this.dataset.arrowsMobile) === 'true';
      const pagination = desktop ? this.dataset.paginationDesktop : this.dataset.paginationMobile;
      if (this.prev) this.prev.hidden = !showArrows;
      if (this.next) this.next.hidden = !showArrows;
      if (this.counter) this.counter.hidden = !overflow || pagination !== 'counter';
      if (this.progress) this.progress.hidden = !overflow || pagination !== 'progress';
      if (this.dots) this.dots.hidden = !overflow || pagination !== 'dots';
      if (this.controls) this.controls.hidden = !overflow || (!showArrows && pagination === 'none');
      this.pagination = pagination;
      if (this.dots && this.dots.children.length !== this.positions.length) {
        const fragment = document.createDocumentFragment();
        this.positions.forEach((_, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'impressiko-featured__dot';
          button.dataset.fcDot = String(index);
          button.setAttribute('aria-controls', this.viewport.id);
          button.setAttribute('aria-label', `${this.dataset.positionLabel} ${index + 1}`);
          fragment.appendChild(button);
        });
        this.dots.replaceChildren(fragment);
      }
      this.pending = null;
      if (!this.enabled || !oldEnabled) this.setPosition(0);
      else this.setPosition(this.offsets[Math.min(oldAnchor, this.cards.length - 1)] || 0);
      this.update();
    }

    nearest(value) {
      let best = 0;
      let distance = Infinity;
      this.positions.forEach((position, index) => {
        if (Math.abs(position - value) < distance) {
          distance = Math.abs(position - value);
          best = index;
        }
      });
      return best;
    }

    go(index, smooth = true) {
      if (!this.enabled || this.max < 2) return;
      const clamped = Math.max(0, Math.min(this.positions.length - 1, index));
      this.pending = clamped;
      this.scrollToOffset(this.positions[clamped], smooth);
      if (!smooth || this.motion.matches) this.update(true);
    }

    step(direction) {
      const desktop = this.media.matches;
      const columns = Number(desktop ? this.dataset.columnsDesktop : this.dataset.columnsMobile) || 1;
      const jump = this.dataset.scrollStep === 'page' ? Math.max(1, Math.floor(columns)) : 1;
      this.go((this.pending ?? this.nearest(this.position())) + jump * direction);
    }

    endDrag(snap) {
      const drag = this.drag;
      if (!drag) return;
      this.drag = null;
      if (drag.moved) {
        const position = this.position();
        this.suppressClickUntil = performance.now() + 350;
        this.viewport.classList.remove('is-fc-dragging');
        try { this.viewport.releasePointerCapture(drag.id); } catch (_) { /* Already released. */ }
        if (snap && this.dataset.snap === 'true') this.go(this.nearest(position));
      }
    }

    update(announce = false) {
      if (!this.ready) return;
      const value = this.position();
      this.index = this.nearest(value);
      if (this.prev) this.prev.disabled = value <= 2;
      if (this.next) this.next.disabled = value >= this.max - 2;
      if (this.dots) Array.from(this.dots.children).forEach((button, index) => {
        if (index === this.index) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      if (this.progress) {
        const fraction = (this.index + 1) / this.positions.length;
        this.progress.style.setProperty('--fc-progress', String(fraction));
      }
      const visible = [];
      this.offsets.forEach((offset, index) => {
        const width = this.cards[index].getBoundingClientRect().width;
        if (offset + width > value + 2 && offset < value + this.lastWidth - 2) visible.push(index);
      });
      this.anchor = visible[0] || 0;
      const first = this.anchor + 1;
      const last = (visible[visible.length - 1] ?? this.anchor) + 1;
      const range = first === last ? String(first) : `${first}\u2013${last}`;
      if (this.counter) this.counter.textContent = `${range} / ${this.cards.length}`;
      if (announce && this.status) this.status.textContent = `${this.dataset.listLabel}: ${range} / ${this.cards.length}`;
    }
  }
  customElements.define('imp-featured-carousel', ImpFeaturedCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usp-importance-aplus"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag = 'usp-importance-slider-v2';
  if (customElements.get(tag)) return;
  class USPImportanceSlider extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.init());
    }
    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.scrollFrame);
      cancelAnimationFrame(this.resizeFrame);
      clearTimeout(this.settleTimer);
      this.ready = false;
    }
    init() {
      if (this.ready || !this.isConnected) return;
      this.viewport = this.querySelector('.usp-importance-aplus__viewport');
      this.slides = Array.from(this.querySelectorAll('.usp-importance-aplus__slide'));
      if (!this.viewport || !this.slides.length) return;
      this.ready = true;
      this.index = 0;
      this.dots = Array.from(this.querySelectorAll('.usp-importance-aplus__dot'));
      this.prev = this.querySelector('.usp-importance-aplus__arrow--prev');
      this.next = this.querySelector('.usp-importance-aplus__arrow--next');
      this.status = this.querySelector('.usp-importance-aplus__status');
      this.events = new AbortController();
      const listen = (target, event, callback, options = {}) => {
        target?.addEventListener(event, callback, { ...options, signal: this.events.signal });
      };
      listen(this.prev, 'click', () => this.go(this.index - 1));
      listen(this.next, 'click', () => this.go(this.index + 1));
      this.dots.forEach((dot, i) => listen(dot, 'click', () => this.go(i)));
      listen(this.viewport, 'scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => {
          if (!this.drag?.moved && !this.navigating) this.select(this.nearest());
        });
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => {
          this.navigating = false;
          this.select(this.nearest());
          this.announce();
        }, 140);
      }, { passive: true });
      listen(this.viewport, 'keydown', (event) => {
        if (event.target !== this.viewport) return;
        let target;
        if (event.key === 'ArrowRight') target = this.index + (this.rtl() ? -1 : 1);
        if (event.key === 'ArrowLeft') target = this.index + (this.rtl() ? 1 : -1);
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = this.slides.length - 1;
        if (target === undefined) return;
        event.preventDefault();
        this.go(target);
      });
      listen(this.viewport, 'pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || this.slides.length < 2) return;
        this.blockClickUntil = 0;
        this.drag = { id: event.pointerId, x: event.clientX, scroll: this.viewport.scrollLeft, moved: false };
      });
      listen(window, 'pointermove', (event) => {
        const drag = this.drag;
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX - drag.x;
        if (!drag.moved && Math.abs(dx) < 6) return;
        if (!drag.moved) {
          drag.moved = true;
          this.navigating = false;
          this.viewport.classList.add('dragging');
          this.viewport.setPointerCapture?.(drag.id);
        }
        event.preventDefault();
        this.viewport.scrollLeft = drag.scroll - dx;
      });
      const stop = (event) => {
        const drag = this.drag;
        if (!drag || (event?.pointerId !== undefined && event.pointerId !== drag.id)) return;
        this.drag = null;
        this.viewport.classList.remove('dragging');
        if (this.viewport.hasPointerCapture?.(drag.id)) this.viewport.releasePointerCapture(drag.id);
        if (drag.moved) {
          this.blockClickUntil = performance.now() + 350;
          this.go(this.nearest());
        }
      };
      listen(window, 'pointerup', stop);
      listen(window, 'pointercancel', stop);
      listen(window, 'blur', () => stop());
      listen(this.viewport, 'dragstart', event => event.preventDefault());
      listen(this.viewport, 'click', event => {
        if (performance.now() < (this.blockClickUntil || 0)) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, { capture: true });
      listen(this, 'shopify:block:select', event => {
        const slide = event.target.closest('.usp-importance-aplus__slide');
        const i = this.slides.indexOf(slide);
        if (i >= 0) this.go(i, false);
      });
      this.querySelectorAll('img').forEach(image => listen(image, 'load', () => this.fitHeight()));
      const resize = () => {
        cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = requestAnimationFrame(() => {
          const width = this.viewport.clientWidth;
          if (Math.abs(width - (this.lastWidth || 0)) > 0.5) {
            this.lastWidth = width;
            this.go(this.index, false);
          }
          this.fitHeight();
        });
      };
      listen(window, 'resize', resize, { passive: true });
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(resize);
        this.observer.observe(this.viewport);
        this.slides.forEach(slide => this.observer.observe(slide));
      }
      this.go(0, false);
      resize();
    }
    rtl() { return getComputedStyle(this.viewport).direction === 'rtl'; }
    position(i) {
      const slide = this.slides[i].getBoundingClientRect();
      const view = this.viewport.getBoundingClientRect();
      const max = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      const offset = this.rtl()
        ? slide.right - view.right + this.viewport.scrollLeft
        : slide.left - view.left + this.viewport.scrollLeft;
      return this.rtl() ? Math.max(-max, Math.min(0, offset)) : Math.min(max, Math.max(0, offset));
    }
    nearest() {
      let best = 0;
      let distance = Infinity;
      this.slides.forEach((slide, i) => {
        const d = Math.abs(this.position(i) - this.viewport.scrollLeft);
        if (d < distance) { distance = d; best = i; }
      });
      return best;
    }
    go(i, smooth = true) {
      i = Math.max(0, Math.min(this.slides.length - 1, i));
      this.select(i);
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.navigating = smooth && !reduced;
      const previous = this.viewport.style.scrollBehavior;
      if (!this.navigating) this.viewport.style.scrollBehavior = 'auto';
      this.viewport.scrollTo({ left: this.position(i), behavior: this.navigating ? 'smooth' : 'auto' });
      if (!this.navigating) this.viewport.style.scrollBehavior = previous;
      clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(() => {
        this.navigating = false;
        this.select(this.nearest());
        if (smooth) this.announce();
      }, 600);
    }
    select(i) {
      this.index = i;
      this.dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === i);
        dot.setAttribute('aria-current', index === i ? 'true' : 'false');
      });
      if (this.prev) this.prev.disabled = i === 0;
      if (this.next) this.next.disabled = i === this.slides.length - 1;
      this.fitHeight();
    }
    fitHeight() {
      const card = this.slides[this.index]?.querySelector('.usp-importance-aplus__card');
      if (!card) return;
      const height = Math.ceil(card.getBoundingClientRect().height);
      if (height > 0 && this.viewport.style.height !== `${height}px`) this.viewport.style.height = `${height}px`;
    }
    announce() {
      if (this.status) this.status.textContent = `Slide ${this.index + 1} of ${this.slides.length}`;
    }
  }
  customElements.define(tag, USPImportanceSlider);
})();

  } catch(e) { console.error(e); }
})();
})();
